module.exports = __webpack_public_path__ + "static/62import-c13a85f004916e7b7004cad49d136633.png";